import { Controller } from "@hotwired/stimulus"
import { shareText } from "../lib/share_text"

// Lets users export the current page (standings, roster, scores) as a PDF via
// the browser's native print dialog, or share it through the device's native
// share sheet (WhatsApp, email, etc.) when available. When the page provides
// a ready-made message (data-share-text-value, e.g. the súmula) that text is
// what goes out; otherwise it's just the page link.
export default class extends Controller {
  static targets = ["copied"]
  static values = { text: String }

  print() {
    window.print()
  }

  async share() {
    if (this.hasTextValue) {
      await shareText(this.textValue)
      return
    }

    const data = { title: document.title, url: window.location.href }

    if (navigator.share) {
      try {
        await navigator.share(data)
      } catch (error) {
        // User cancelled the share sheet — nothing to do.
      }
      return
    }

    if (navigator.clipboard) {
      await navigator.clipboard.writeText(data.url)
      this.showCopied()
    }
  }

  showCopied() {
    if (!this.hasCopiedTarget) return
    this.copiedTarget.classList.remove("hidden")
    setTimeout(() => this.copiedTarget.classList.add("hidden"), 2000)
  }
}
